import { isNil } from "lodash";
import PropTypes from "prop-types";
import React, { createRef, PureComponent } from "react";

import {
  stringFromTimespan,
  timespanForString
} from "../../modules/definition/calendar/dateFunctions/timespanFunctions";
import { PropTypeShapes } from "../../types";
import { withPortalChildContext } from "../portal/PortalChildContext";
import FormTextField from "./FormTextField";

class FormDurationPicker extends PureComponent {
  constructor(props, context) {
    super(props, context);
    this.onChange = this.onChange.bind(this);
    this.focus = this.focus.bind(this);
    this._fieldRef = createRef();
  }

  getTimespanStringValue(value) {
    return !isNil(value) ? (!isNil(value.label) ? value.label : stringFromTimespan(value)) : "";
  }

  onChange(value) {
    const { validator } = this.props;
    let span = null;
    if (value !== "") {
      span = timespanForString(value, this.props.calendar);
      span = span && (!validator || validator(span)) ? span : null;
    }
    this.props.onChange(span);
  }

  focus() {
    if (this._fieldRef && this._fieldRef.current) {
      this._fieldRef.current.focus();
    }
  }

  render() {
    const value = this.getTimespanStringValue(this.props.value);

    return (
      <FormTextField
        ref={this._fieldRef}
        disabled={Boolean(this.props.disabled)}
        onChange={this.onChange}
        value={value}
        noBlurOnCommit={this.props.noBlurOnCommit}
      />
    );
  }
}

FormDurationPicker.propTypes = {
  value: PropTypes.oneOfType([PropTypeShapes.timespanDisplayRecord, PropTypeShapes.timespanRecord]),
  //TODO: do we need calendar here?
  calendar: PropTypeShapes.calendar,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  validator: PropTypes.func,
  autoFocus: PropTypes.bool,
  noBlurOnCommit: PropTypes.bool,

  // From withPortalChildContext
  portalChildContext: PropTypes.object
};

let Component = FormDurationPicker;
//#!if iOS === true
// Component = withPortalChildContext(Component);
//#!endif

export default Component;
